import {format} from '../utils/string-utils';

/**
 * @ngdoc filter
 * @name strParams
 * @module portaro.filters
 * @kind function
 *
 * @param {string} string Input string
 * @param {...string} params Regexp expressions in string
 *
 * @return {string} Formatted number
 *
 * @description
 * This filter provides a means to produce concatenated messages in a language-neutral way. Use this to construct messages displayed for end users.
 * It takes a set of objects, formats them, then inserts the formatted strings into the pattern at the appropriate places.
 * See <a href="https://docs.oracle.com/javase/7/docs/api/java/text/MessageFormat.html#format(java.lang.String,%20java.lang.Object...)" target="_blank">Java MessageFormat#format</a>
 */
export default function strParamsFilter(): (_: string, ...params: string[]) => string {
    return (value: string, ...params: string[]) => {
        if (value) {
            return format(...params)(value);
        }
        return value;
    };
}

strParamsFilter.filterName = 'strParams';